const React = require('react');
const DownloadIcon = require('../../../../../icons/Download');
const downloadReportDocument = require('../../../../../../utils/downloadReportDocument');
const BtnTableGlobal = require('../BtnTableGlobal');

module.exports = ({filter, sort = {}, report, ...rest}) => {
  return (
    <BtnTableGlobal
      icon={DownloadIcon}
      text="csv"
      onClick={() => downloadReportDocument(filter, sort, report)}
      testId="tableDownloadCSV"
    />
  )
}
